import { ElementType } from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

export type AppButtonProps<C extends ElementType = 'button'> = ButtonProps<C> & {
  loading?: boolean;
  /** Green athletic CTA styling (public marketing / primary actions). */
  sport?: boolean;
};

const sportSx = {
  bgcolor: '#00c853',
  color: '#0d1b2a',
  fontWeight: 800,
  '&:hover': { bgcolor: '#00e676' },
};

export default function AppButton<C extends ElementType = 'button'>({
  loading,
  sport,
  children,
  disabled,
  sx,
  variant = 'contained',
  ...props
}: AppButtonProps<C>) {
  return (
    <Button
      variant={variant}
      disabled={disabled || loading}
      sx={sport ? { ...sportSx, ...(sx && typeof sx === 'object' && !Array.isArray(sx) ? sx : {}) } : sx}
      {...props}
    >
      {loading ? <CircularProgress size={22} color="inherit" /> : children}
    </Button>
  );
}
